import { useQuery } from '@tanstack/react-query';
import { resourceApi } from '../api/resourceApi';

export const useResources = (
  page: number = 1,
  limit: number = 10,
  search?: string,
  category?: string,
) => {
  return useQuery({
    queryKey: ['resources', page, limit, search, category],
    queryFn: () => resourceApi.getResources(page, limit, search, category),
  });
};

export const useResourcesOverview = () => {
  return useQuery({
    queryKey: ['resources', 'overview'],
    queryFn: () => resourceApi.getResourcesOverview(),
  });
};
